export const DEFAULT_PAGE_CONFIG = { columns: {}, columnOrder: [] };

export const CONFIG_KEY = 'configuration_json';

export const NAV_BAR_HEIGHT = 92; // 72 + 20 top padding

export const TOOLBAR_HEIGHT = 76;

export const DEFAULT_PAGINATION_SETTINGS = {
  page: 1,
  pageSize: 10,
  search: '',
  ordering: 'name',
};

export const APPLY_TEMPLATE_PARAM = 'apply_template';
